import { Text, VStack } from "@leplein/ui";
import { useTranslation } from "react-i18next";

export const NotFoundPage = () => {
	const { t } = useTranslation("common");

	return (
		<VStack space="lg" className="py-4">
			<Text size="sm" className="text-center">
				{t("error.headline")}
			</Text>
			<Text size="2xl" extraBold className="text-center">
				{t("error.heading")}
			</Text>
		</VStack>
	);
};
